'use strict';

const Pagination = require('framework/domain/value/pagination');
const ReadMoreCollection = require('framework/domain/collection/readmore-collection');

module.exports = class IdeaCollection extends ReadMoreCollection {
    constructor(models, options) {
        super(models, options);

        this._repository = options.repository;
        this._scope = options.scope;
        this._user = options.user;

        this.listenTo(this._repository, 'add', idea => {
            if(this.isBelongToSomePage(idea)) {
                this.add(idea);
            }
        });
    }

    model2number(model) {
        return - model.getUpdatedAt().unix();
    }

    isBelongToCollection(model) {
        if (this._scope === "public") {
            return model.isPublic();
        }
        if (this._scope === "my") {
            return model.getRequestUserID() === this._user.id;
        }
        return false;
    }

    fetch(limit, cursor) {
        return this._repository.fetch(this._scope, limit, cursor)
            .then(result => {
                const pagination = result.pagination;
                return {
                    models: result.models,
                    pagination: new Pagination(
                        pagination.totalCount,
                        pagination.prevCursor,
                        pagination.prevMore,
                        pagination.nextCursor,
                        pagination.more
                    )
                }
            });
    }
};



// WEBPACK FOOTER //
// ./feedback/domain/collection/idea.js